<template>
  <label class="icon-box" @click="handleClick">
    <auth-img class="icon-img" src="@/assets/img/chat/upload.png" alt="" />
    <div class="icon-label">量表</div>
    <a-modal
      title="随访量表"
      width="650px"
      v-model:visible="visible"
      :bodyStyle="bodyStyle"
      cancelText="取消"
      :ok-button-props="{ disabled: loading || Boolean(!gaugeValue.length) }"
      okText="确定"
      @ok="handleOk"
      centered
    >
      <div v-if="surveyList && surveyList.length > 0" class="gauge-box">
        <a-checkbox-group v-model:value="gaugeValue">
          <a-checkbox
            v-for="(item, index) in surveyList"
            :key="`${item.surveyType}-${item.id}`"
            :style="radioStyle"
            :value="`${item.surveyType}-${item.id}`"
          >
            <span class="surveyItem">
              {{ index + 1 }}、{{ item.name }}
              <span v-if="item.clinicalFlag" class="clinic-flag">临观</span>
              <!-- <auth-img
                src="@/assets/img/work-place/lin-guan.png"
                alt="临观标签"
                v-if="!item.clinicalFlag"
                style="margin-right: 4px"
              /> -->
              <a :href="item.url" target="_blank" class="go-detail">查看</a>
            </span>
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div class="empty-box" v-else>
        <auth-img class="empty-img" src="@/assets/img/empty.png" alt="缺损" />
      </div>
    </a-modal>
  </label>
</template>

<script setup>
import { defineProps, ref, reactive } from 'vue'
import { getSurveyList, surveySend } from '@/api/chat'
import { message as Message } from 'ant-design-vue'
import { useStore } from 'vuex'
const store = useStore()
const visible = ref(false)
const gaugeValue = ref([])
const surveyList = ref([])
const loading = ref(false)
const radioStyle = reactive({
  display: 'block',
  height: '30px',
  lineHeight: '30px',
  color: '#333333',
  marginBottom: '32px'
})
const bodyStyle = reactive({
  padding: '40px'
})
const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    required: true,
    default: () => {}
  },
  chatId: {
    type: [String, undefined],
    default: ''
  },
  surveySource: {
    //量表来源
    type: [Number, null],
    required: false,
    default: null
  }
})
const handleClick = () => {
  const { doctorInfo = {} } = props.workOrderGroupInfo || {}
  if (doctorInfo.businessId) {
    getSurveyList({ doctorId: doctorInfo.businessId }).then(res => {
      surveyList.value = res
      visible.value = true
    })
  } else {
    getSurveyList().then(res => {
      surveyList.value = res
      visible.value = true
    })
  }
}
const handleOk = () => {
  const sessionWorkInfo = sessionStorage.getItem('CURRENT_WORKORDER_INFO') || '{}'
  const workInfo = JSON.parse(sessionWorkInfo)
  if (!gaugeValue.value.length) return Message.warning('请选择量表')
  const { doctorInfo = {}, patientInfo = {} } = props.workOrderGroupInfo || {}
  const { activityFlag } = workInfo
  const selectedSurvey = surveyList.value.filter(item =>
    gaugeValue.value.includes(`${item.surveyType}-${item.id}`)
  )
  const surveyVOList = selectedSurvey.map(item => {
    return {
      surveyId: item.id,
      activityFlag,
      surveySource: props.surveySource,
      surveyType: item.surveyType
    }
  })
  const newParams = {
    surveyVOList,
    doctorId: doctorInfo.businessId,
    patientId: patientInfo.businessId,
    sendTime: new Date().getTime(),
    assistantId: store.getters.userId,
    groupId: props.chatId
  }
  // if (!doctorInfo.businessId) delete params.doctorId
  if (!doctorInfo.businessId) delete newParams.doctorId
  loading.value = true
  surveySend(newParams)
    .then(() => {
      Message.success('发送成功')
    })
    .finally(() => {
      visible.value = false
      gaugeValue.value = []
      setTimeout(() => {
        loading.value = false
      }, 0)
    })
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';
::v-deep(.ant-checkbox-wrapper + .ant-checkbox-wrapper) {
  margin-left: 0;
}

.gauge-box {
  max-height: 70vh;
  overflow: scroll;
}
.surveyItem {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  // :hover {
  //   .go-detail {
  //     opacity: 1;
  //   }
  // }
  .clinic-flag {
    padding: 0px 5px;
    border: 1px solid #d35656;
    color: #d35656;
    font-size: 12px;
    border-radius: 12px;
    margin-left: 5px;
  }
  .go-detail {
    font-size: 16px;
    color: #1890ff;
    float: right;
  }
}
</style>
